'use client';

import { useEffect } from 'react';
import NotFoundContent from '@/components/NotFoundContent/NotFoundContent';
import { logError } from '@/utils/log';

const ClientNotFound = ({ statusCode, errorMessage }) => {
  useEffect(() => {
    logError({ error: { name: String(statusCode), message: errorMessage } });
  });

  return (
    <div className="flex-grow">
      <NotFoundContent statusCode={statusCode} />
    </div>
  );
};

export default ClientNotFound;
